
<ng-container *ngIf="isLoading$ | async as isLoading; else content">
    <mat-spinner></mat-spinner>
  </ng-container>
  
  <ng-template #content>
      <h2 class="title" style="padding: 10px;">Ruta calculada</h2>
        <div class="modal" *ngIf="calculatedRoute$ | async as calculatedRoute">
            <mat-card style="width: 100%; height: 100%;">  
              <app-map
              [fromLocation]="calculatedRoute.from_location"
              [toLocation]="calculatedRoute.to_location"
              [routeCoordinates]="transformedRouteCoordinates"
              [partner]="(partner$ | async) || null"
              >
            </app-map>
            </mat-card>
            <div class="content">
                 
                <div class="route-info">
                  <section class="route-info__section">
                    <h3 class="title">Información de la ruta</h3>  
                    <p>Distancia calculada:  {{ calculatedRoute.distance }} km</p>
                    <p>Tiempo estimado: {{ calculatedRoute.duration | number:'1.0-0' }} minutos</p>
                  </section>

                  <section class="route-info__section">
                    <h3 class="title">Costos de la ruta</h3>
                    <p *ngIf="calculatedRoute?.calculated_price">Costo por kilómetros: {{ calculatedRoute.calculated_price }} USD</p>
                    <p *ngIf="calculatedRoute?.overweight_price">Sobrepeso: {{ calculatedRoute.overweight_price }} USD</p>
                    <p *ngIf="calculatedRoute?.additional_services_price">Adicional: {{ calculatedRoute.additional_services_price }} USD</p>
                    <p *ngIf="calculatedRoute?.cash_return_price">Retorno Efectivo: {{ calculatedRoute.cash_return_price }} USD</p>
                    <p *ngIf="calculatedRoute?.additional_night_charge">Recargo nocturno: {{ calculatedRoute.additional_night_charge }} USD</p>
                    <p><strong>Total del servicio</strong>: {{ calculatedRoute.price }} USD</p>
                  </section>
                </div>
            </div>
            <div class="button-container">
              <button mat-raised-button color="warn" class="cancel-button" (click)="onCancel()">Cancelar</button>
              <button mat-flat-button class="accept-button" color="primary" (click)="onAccept()">Aceptar</button>
          </div>
        </div>
    </ng-template>